import React from "react";

export const SplashLayout = (props) => {
    return (
        <div className="login-layout-splash">
            <div className="login-layout-splash-main">
                {props.children}
            </div>
        </div>
    );
};